var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3929 17.306L13.8709 12.6029C15.0336 11.2207 15.6706 9.48166 15.6706 7.67124C15.6706 3.44139 12.2292 0 7.99937 0C3.76951 0 0.328125 3.44139 0.328125 7.67124C0.328125 11.9011 3.76951 15.3425 7.99937 15.3425C9.58731 15.3425 11.1005 14.8635 12.3943 13.9543L16.9507 18.6932C17.1412 18.8909 17.3973 19 17.6718 19C17.9316 19 18.1781 18.9009 18.3652 18.7208C18.7628 18.3383 18.7755 17.7039 18.3929 17.306ZM7.99937 2.00119C11.1259 2.00119 13.6694 4.54471 13.6694 7.67124C13.6694 10.7978 11.1259 13.3413 7.99937 13.3413C4.87284 13.3413 2.32932 10.7978 2.32932 7.67124C2.32932 4.54471 4.87284 2.00119 7.99937 2.00119Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.74bc3b4804d51883fc4a89c195d86022.svg";
export { ForwardRef as ReactComponent };